import { useSnapshot } from "valtio";
import { localState } from "~/state/state";
import { isIOSNativeApp } from "~/utils/deviceDetection";

export const HelpButton = ({
  text,
  isOnBillingPage,
  isOnProPage,
}: {
  text?: string;
  isOnBillingPage?: boolean;
  isOnProPage?: boolean;
}) => {
  const { isInRoom, inDarkMode: roomDarkMode, appDarkMode } = useSnapshot(localState);

  // Hide feedback button for iOS native app
  if (isIOSNativeApp()) {
    return null;
  }

  // inDarkMode is forced on by dark rooms. The plans page also follows the app theme.
  const inDarkMode = roomDarkMode || (!!isOnBillingPage && !isInRoom && appDarkMode);

  let backgroundColor = inDarkMode ? "black" : "white";
  const color = inDarkMode ? "white" : "black";
  if (isOnProPage) {
    backgroundColor = inDarkMode
      ? "var(--colors-darkwashA500)"
      : "var(--colors-washA500)";
  }

  let border = `.5px solid ${color}`;
  if (isOnProPage) {
    border = `1px solid ${
      inDarkMode ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.5)"
    }`;
  }

  const fontSize = isOnProPage ? "15px" : "11px";

  const borderRadius = isInRoom ? "40px" : isOnProPage ? "50%" : isOnBillingPage ? "50px" : "12px";

  const padding = isInRoom ? "9px 16px" : isOnProPage ? "6px 11px" : isOnBillingPage ? "5px" : "6px 10px";

  const buttonContent = text
    ? text
    : isOnBillingPage
      ? `<img src="/images/feedback.svg" style="width: 20px; height: 20px; display: block; opacity: 0.7; filter: ${inDarkMode ? "invert(1)" : "none"};" />`
      : "Feedback";

  return (
    <div
      style={{
        position: "fixed",
        bottom: isInRoom ? "6px" : isOnBillingPage ? "22px" : "66px",
        right: isInRoom ? "12px" : isOnBillingPage ? "24px" : "16px",
        cursor: "pointer",
        zIndex: isInRoom ? "unset" : "4",
        marginBottom: isOnProPage ? "-6px" : "unset",
      }}
      dangerouslySetInnerHTML={{
        __html: ` <button
        id="support"
class="custom-button"
style="background-color: ${backgroundColor}; color: ${color}; border: ${border}; cursor: pointer; border-radius: ${borderRadius}; font-size: ${fontSize}; padding: ${padding}; display: flex; align-items: center; justify-content: center;"
onclick="videoask.loadModal('https://www.videoask.com/fcaqxaw1l')"
>
${buttonContent}
</button>`,
      }}
    />
  );
};

export const HelpButtonSmall = () => {
  const { isInRoom, inDarkMode, appDarkMode } = useSnapshot(localState);

  // Hide small feedback button for iOS native app
  if (isIOSNativeApp()) {
    return null;
  }

  // inDarkMode is forced on by dark rooms and the session player; outside a
  // room (and when not forced) fall back to the app theme
  const dark = inDarkMode || (!isInRoom && appDarkMode);
  const backgroundColor = dark ? "black" : "white";
  const color = dark ? "white" : "black";
  const filter = dark ? "invert(1)" : "none";
  return (
    <div
      style={{}}
      dangerouslySetInnerHTML={{
        __html: ` <button
class="custom-button"
style="background-color: ${backgroundColor}; color: ${color}; pointer-events: all; border: 1px solid ${color}; margin-top: 10px; cursor: pointer;  border-radius: 50%;  width:30px; height:30px; display:flex; padding:0; justify-content:center; align-items: center;"
onclick="videoask.loadModal('https://www.videoask.com/fcaqxaw1l')"
>
<img style="filter: ${filter}" src="/images/room/question.svg">
</button>`,
      }}
    />
  );
};
